import { render, staticRenderFns } from "./BackProduct.vue?vue&type=template&id=b2329f5e&scoped=true&"
import script from "./BackProduct.vue?vue&type=script&lang=js&"
export * from "./BackProduct.vue?vue&type=script&lang=js&"
import style0 from "./BackProduct.vue?vue&type=style&index=0&id=b2329f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2329f5e",
  null
  
)

component.options.__file = "BackProduct.vue"
export default component.exports